import React from 'react';
import { CateringRequestsHistoryProps, FirebaseCateringRequest } from './types';
import { useTranslation } from 'react-i18next';
import useAuthState from '../../../global-states/useAuthState';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

export const CateringRequestsBox: React.FC<CateringRequestsHistoryProps> = (
  props
) => {
  const { t } = useTranslation(['catering']);
  const auth: any = useAuthState.getState();
  const history = useHistory();

  const handleCardClick = (requestID: string | undefined) => {
    history.push(`/catering/${requestID}`);
  };

  return (
    <>
      <div className='flex flex-wrap mt-6'>
        {props.requests &&
          props.requests.map((request: FirebaseCateringRequest) => (
            <div className='w-6/12 md:w-4/12 p-2' key={request.requestID}>
              <div
                className='bg-white p-3 h-60 rounded-xl text-sm cursor-pointer'
                onClick={() => handleCardClick(request.requestID)}
              >
                <div className='bg-gray-100 p-2 rounded-md text-center font-bold'>
                  {request.requestID.toUpperCase().toString()}
                </div>
                <div className='py-2 mt-2 text-center font-bold truncate'>
                  {request.customer.name}
                  <div className='py-1 text-center text-sm font-normal'>
                    {request.customer.email}
                  </div>
                </div>
                <div className='px-2 py-1 flex justify-center align-middle text-center font-normal'>
                  <p className='text-lg text-left text-gray-500 flex items-center'>
                    <span className='flex flex-row gap-2'>
                      <p>{request.peopleNumber}</p>
                      💁
                    </span>
                  </p>
                </div>

                <div className='p-2 mt-2 text-gray-500 text-center font-light truncate'>
                  {request.eventTimeStamp &&
                    moment(request.eventTimeStamp).format('ddd D MMMM')}
                </div>

                <div>
                  {request.requestStatus === 'received' && (
                    <div className='rounded-md p-2 h-7 bg-light_blue opacity-80 flex justify-center items-center'>
                      <span className='text-blue-900'>
                        {t('pending.label')}
                      </span>
                    </div>
                  )}
                  {request.requestStatus === 'confirmed' && (
                    <div className='rounded-md p-2 h-7  bg-light_green flex opacity-80 justify-center items-center'>
                      <span className='text-green-900'>
                        {t('confirmed_status.label')}
                      </span>
                    </div>
                  )}
                  {request.requestStatus === 'rejected' && (
                    <div className='rounded-md p-2 h-7 bg-red-100 flex opacity-80 justify-center items-center'>
                      <span className='text-red-900'>
                        {t('rejected_status.label')}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>

      <div className='flex justify-center align-middle'>
        {!props.noRequestsLeft ? (
          <div className='flex pt-2'>
            <button
              onClick={() => {
                !props.requestsLoading && props.fetchMore(auth.user);
              }}
              className={`add_button w-80 ${
                props.moreRequestsLoading ? 'opacity-20' : null
              }`}
              style={{ width: '230px' }}
              disabled={props.moreRequestsLoading}
            >
              {t('loadMore.button')}
              {props.moreRequestsLoading && (
                <div className='flex justify-center align-middle'>
                  <svg
                    role='status'
                    className='m-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-droov'
                    viewBox='0 0 100 101'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                      fill='currentColor'
                    />
                    <path
                      d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                      fill='currentFill'
                    />
                  </svg>
                </div>
              )}
            </button>
          </div>
        ) : (
          <div
            className={
              'mx-2 p-2 flex bg-white justify-center text-sm font-bold text-blue-900 uppercase tracking-wider rounded-xl cursor-default focus:ring-0 w-full'
            }
          >
            {t('allrequestsloaded.label')}
          </div>
        )}
      </div>
    </>
  );
};
